

const colors = {
    cash: "#fffd9d",
    payable: "#d1ebb3",
    revenue: "#ffa6ff",
    expense: "#ff998d"
};

export default colors;
